import api from "@/assets/scripts/api";
import { getLabelStyleMenu, sortMaterialsByFreshness } from "@/assets/scripts/common.js";
import { randomSort, uploadImg } from "@/assets/scripts/features";
import { base64toFile } from "@/assets/scripts/utils";
import { getSizes } from "@/pages/banner/js/banner-feature";
import { normalImgTextItem } from "@/pages/poster/js/poster-long-static";
import { iconStyleMap } from "@/pages/poster/js/poster-static";
import http from "@/plugins/http";
const commonTextDemand = `返回内容要求：
    1. 文案内容要符合主题，并且必须符合教育行业特征，与初中、高中教育、教学、考试高度相关。
    2. json中texts的长度就是文案的数量，分别是第一行、第二行等。
    3. 文案长度要严格符合尺寸数据中的限制，比如："limit:'4-15'"，那么文案长度必须是4到15个字。
    4. 不同尺寸之间的文案内容要尽可能相同，因为只是同一个banner的不同尺寸。
    5. 每行文案长度在限制范围内尽可能长，比如："limit:3-5"，文案长度就是5个字，每一行都要符合这个要求，这条要求非常重要！！！
    6. 直接返回JavaScript可解析的json字符串，不要返回任何其他内容，以纯文本返回，不要以markdown格式返回!
    7. 不要返回任何其他内容，比如："\`\`\`json"、"\`\`\`"、"\`\`\`"等。`;
// 获取热词推荐
export const getHotWords = async keyWords => {
  let result = await http.post(api.hotWords, {
    words: `根据关键词${keyWords}联想出6句热点句子，请注意以下要求：
          1、每句话不超过10个字；
          2、每句话与给出的关键词紧密相关；
          3、直接返回JavaScript可解析的json字符串，不要返回任何其他内容，以纯文本返回，不要以markdown格式返回；
          4、返回结果和小学初中高中教育、教学、考试高度相关；
          6、不要返回任何其他内容，比如："\`\`\`json"、"\`\`\`"、"\`\`\`"等；
          以下是一个示例
          输入：高考
          输出：[高考作文冲刺宝典,高考数学分析,全国高考一卷解析]`,
  });
  if (result.code === 10000) {
    try {
      return purifyAiStr(result.data);
    } catch (error) {
      return [];
    }
  }
  return [];
};
// 获取海报文案
export const getPosterPaperwork = async keyWords => {
  try {
    const id = process.env.VUE_APP_POSTER_SIZE_ID;
    const textInfoArr = [
      {
        id,
        texts: [
          {
            limit: "4-10",
            name: "副标题",
          },
          {
            limit: "6-20",
            name: "主标题",
          },
          {
            limit: "4-8",
            name: "内容标题",
          },
          {
            limit: "6-14",
            name: "内容item1",
          },
          {
            limit: "6-14",
            name: "内容item2",
          },
          {
            limit: "6-14",
            name: "内容item3",
          },
          {
            limit: "6-14",
            name: "内容item4",
          },
          {
            limit: "14-24",
            name: "底部标题",
          },
          {
            limit: "8-10",
            name: "引导文案",
          },
        ],
      },
    ];
    const content = `我现在要给一个海报上加上文案，海报的每行文案都有对应的字数限制和名称，都在下方的json中给出。请你根据以下主题，
    给出海报文案内容，并将生成的文案内容，直接填充到json数据中的对应位置。比如：[
      {
        "texts": [
          {
            "limit": "4-15",
            "name": "副标题",
            "text": "高中语文期末真题复习能力提升"
          },
          {
            "limit": "8-10",
            "name": "主标题",
            "text": "高考考试易错题讲练集"
          }
        ]
      }
    ]
    ${commonTextDemand}
    以下是本次主题和json数据。
    主题：
    ${keyWords}
    文案数据：
    ${JSON.stringify(textInfoArr)}`;
    let result = await http.post(api.aiGenText, {
      words: content,
    });
    if (result.code === 10000) {
      const data = purifyAiStr(result.data);
      const posterData = data.find(item => item.id === id) || thumbSize;
      return posterData.texts.map(item => item.text);
    }
  } catch (error) {
    return [];
  }
};
// 获取banner文案
export const getPaperworks = async (keyWords, bannerTextLimits) => {
  const sizeDataString = JSON.stringify(bannerTextLimits);
  const content = `我现在要给一个banner上加上文案，但是该banner有多个尺寸，所有的banner尺寸和对应的文案字数限制，都在下方的json中给出。请你根据以下主题，
    给出banner文案内容，并将生成的文案内容，直接填充到json数据中的对应位置。比如：[
      {
        "texts": [
          {
            "limit": "4-15",
            "text": "高中语文期末真题复习能力提升"
          },
          {
            "limit": "8-10",
            "text": "高考考试易错题讲练集"
          }
        ]
      }
    ]
    ${commonTextDemand}
    以下是本次主题和尺寸数据。
    主题：
    ${keyWords}
    尺寸数据：
    ${sizeDataString}`;
  try {
    let result = await http.post(api.aiGenText, {
      words: content,
    });
    if (result.code === 10000) {
      try {
        return purifyAiStr(result.data);
      } catch (error) {
        return [];
      }
    }
  } catch (error) {
    return [];
  }
};
export const getPaperworkBySizeId = (allPaperworks, sizeId) => {
  if (!allPaperworks.length) return [];
  const sizeData = allPaperworks.find(s => s.id === sizeId);
  if (!sizeData) return [];
  return sizeData.texts.map(s => s.text);
};
// 获取封面尺寸信息
export const getSizeInfoBySizeId = (groupSizes, sizeId) => {
  for (const group of groupSizes) {
    for (const size of group.sizes) {
      if (size.id === parseInt(sizeId)) {
        return size;
      }
    }
  }
  return groupSizes[0].sizes[0];
};
// 获取背景图
export const getMaterialsByWords = async (keyword, materialType) => {
  const authKey = process.env.VUE_APP_VECTOR;
  try {
    const res = await http.post(
      api.materials,
      {
        keyword, //搜索的关键词
        limit: 60, //返回的条数
        type: materialType,
      },
      {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authKey}`,
      }
    );
    const arrs = res.result.map(item => ({
      id: item.id,
      materialTypeId: item.material_type_id,
      src: item.file_path,
      tagBgColor: item.tag_bg_color || "",
      tagIds: (item.tag_ids || "").split(","),
      textShadowColor: item.text_shadow_color || "",
      uploadTime: item.upload_time || "",
    }));
    return sortMaterialsByFreshness(arrs);
  } catch (error) {
    console.error("测试失败: ", error.response?.data || error.message);
    return [];
  }
};
// 获取banner尺寸
export const getBannerSizes = async textStyleId => {
  let params = {
    textStyleId,
    platformType: 1,
  };
  const rawSizes = await getSizes(params);
  return rawSizes;
};
// 获取cover尺寸
export const getCoverSizes = async () => {
  let params = {
    platformType: 2,
  };
  const rawSizes = await getSizes(params);
  return rawSizes;
};

// 将尺寸列表转换为只有文字limit的数据，只返回特殊尺寸、指定尺寸的文字限制
export const getBannerTextLimit = (groups, sizeId) => {
  const sizes = [];
  // 遍历对象的所有属性
  groups.forEach(group => {
    group.sizes.forEach(size => {
      const texts = [];
      if (size.type === 1 || size.id === parseInt(sizeId)) {
        sizes.push({
          id: size.id,
          texts,
        });
        size.textStyle.forEach(text => {
          var l = text.textCountLimit.replace("<x<", "-");
          texts.push({
            limit: l,
          });
        });
      }
    });
  });
  return sizes;
};
export const getCoverTextLimit = groups => {
  const sizes = [];
  // 遍历对象的所有属性
  groups.forEach(group => {
    group.sizes.forEach(size => {
      const texts = [];
      sizes.push({
        id: size.id,
        texts,
      });
      size.textStyle.forEach(text => {
        var l = text.textCountLimit.replace("<x<", "-");
        texts.push({
          limit: l,
        });
      });
    });
  });
  return sizes;
};
//
const purifyAiStr = str => {
  // 移除中括号前后的字符
  const bracketContent = str.match(/\[.*\]/);
  if (bracketContent) {
    try {
      return JSON.parse(bracketContent[0]).filter(item => item);
    } catch (error) {
      return [];
    }
  }
  return [];
};
// 防抖
export const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(args), wait);
  };
};
// 节流
export const throttle = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(args), wait);
  };
};
export const products = [
  {
    name: "海报",
    enName: "poster",
    isShow: true,
  },
  {
    name: "banner",
    enName: "banner",
    isShow: true,
  },
  {
    name: "封面",
    enName: "cover",
    isShow: true,
  },
];
export const thumbSize = {
  id: 0,
  texts: [
    { limit: "4-6", text: "" },
    { limit: "8-10", text: "" },
  ],
};

// 生成的海报文案附到海报数据上
export const genPosterTextMapFromAi = (texts, posterTextMaps) => {
  const textMaps = JSON.parse(JSON.stringify(posterTextMaps));
  if (!texts || !texts.length) return textMaps;
  // ai海报默认四条普通文案
  const item = JSON.parse(JSON.stringify(normalImgTextItem));
  textMaps[1].editOptions.items.push(item);
  textMaps[0].editOptions.subtitle.text = texts[0];
  textMaps[0].editOptions.title.text = texts[1];
  textMaps[1].editOptions.floorName.text = texts[2];
  textMaps[1].editOptions.items[0].content.text = texts[3];
  textMaps[1].editOptions.items[1].content.text = texts[4];
  textMaps[1].editOptions.items[2].content.text = texts[5];
  textMaps[1].editOptions.items[3].content.text = texts[6];
  textMaps[2].editOptions.floorName.text = texts[7];
  textMaps[2].editOptions.blockContent.tip.text = texts[8];
  textMaps[2].editOptions.blockContent.qrImg.src = "";
  return textMaps;
};
// 随机生成一个label样式
export const randomPosterLabelStyle = (posterTextMaps, tagBgColor) => {
  // 海报主标题添加随机label样式
  const labelStyleMap = getLabelStyleMenu(tagBgColor);
  const labelStyle = randomSort(Object.values(labelStyleMap))[0];
  const subtitle = posterTextMaps[0].editOptions.subtitle;
  subtitle.labelStyle = labelStyle.id;
  subtitle.showLabelStyle = true;
  // 普通图文的第一个item添加随机label样式
  const normalImgTextItem = posterTextMaps[1].editOptions.items[0].content;
  const iconStyle = randomSort(Object.values(iconStyleMap))[0];
  normalImgTextItem.labelStyle = iconStyle.id;
  normalImgTextItem.showLabelStyle = true;
  normalImgTextItem.isLabelStyle = true;
};
// 生成mj图片
export const mjGenImage = async (prompt) => {
  try {
    const result = await http.post(api.mjGenImage, {
      prompt,
    });
    console.log("mjGenImage生成mj图片", result);
    return result.data.imageUrl || "";
  } catch (error) {
    console.log("mjGenImage生成mj图片失败", error);
    return "";
  }
};
// 抠图
export const removeBackground = async (imageUrl) => {
  const result = await http.post(api.removeBackground, {
    imageUrl,
  });
  if (result.code === 10000) {
    return result.data;
  }
  return { imageUrl: "" };
};
// 裁剪方法
export const cropImageWithCanvas = (drawOptions) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  canvas.width = 2000;
  canvas.height = 500;
  drawOptions.forEach((option) => {
    ctx.drawImage(
      option.img,
      option.sx,// 源图像上裁剪区域的 X 轴起始位置
      option.sy, // 源图像上裁剪区域的 Y 轴起始位置
      option.sWidth, // 源图像上裁剪区域的宽度
      option.sHeight, // 源图像上裁剪区域的高度
      option.dx, // 目标画布上 X 轴的起始位置
      option.dy, // 目标画布上 Y 轴的起始位置
      option.dWidth, // 在目标画布上绘制图像的宽度
      option.dHeight // 在目标画布上绘制图像的高度
    );
  })
  return canvas.toDataURL("image/png");
}
export const loadImage = (imgUrl) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = imgUrl;
    img.crossOrigin = "anonymous";
    img.onload = () => {
      resolve(img);
    }
    if (!imgUrl) {
      reject(new Error("图片地址为空"));
    }
  })
}
// 分割mj图片,并绘制四张图片
export const splitMjImage = (images) => {
  const promises = images.map((img) => img && loadImage(img) || Promise.resolve(null));
  return Promise.all(promises).then(([leftImg, rightImg]) => {
    try {
      const imgWidth = (leftImg || rightImg).width;
      const imgHeight = (leftImg || rightImg).height;
      const drawWidth = (imgWidth * 500) / imgHeight;
      const elementWidth = 2000;
      const elementHeight = 500;
      // 第一张图左侧元素
      const firstLeftOptions = leftImg && {
        img: leftImg,
        sx: 0, // 源图像上裁剪区域的 X 轴起始位置
        sy: 0, // 源图像上裁剪区域的 Y 轴起始位置
        sWidth: imgWidth / 2, // 源图像上裁剪区域的宽度
        sHeight: imgHeight / 2, // 源图像上裁剪区域的高度
        dx: 0, // 目标画布上 X 轴的起始位置
        dy: 0, // 目标画布上 Y 轴的起始位置
        dWidth: drawWidth, // 在目标画布上绘制图像的宽度
        dHeight: elementHeight, // 在目标画布上绘制图像的高度
      };
      // 第一张图右侧元素
      const firstRightOptions = rightImg && {
        img: rightImg,
        sx: 0, // 源图像上裁剪区域的 X 轴起始位置
        sy: 0, // 源图像上裁剪区域的 Y 轴起始位置
        sWidth: imgWidth / 2, // 源图像上裁剪区域的宽度
        sHeight: imgHeight / 2, // 源图像上裁剪区域的高度
        dx: elementWidth - drawWidth, // 目标画布上 X 轴的起始位置
        dy: 0, // 目标画布上 Y 轴的起始位置
        dWidth: drawWidth, // 在目标画布上绘制图像的宽度
        dHeight: elementHeight, // 在目标画布上绘制图像的高度
      };
      // 第二张图左侧元素
      const secondLeftOptions = leftImg && {
        img: leftImg,
        sx: imgWidth / 2, // 源图像上裁剪区域的 X 轴起始位置
        sy: 0, // 源图像上裁剪区域的 Y 轴起始位置
        sWidth: imgWidth / 2, // 源图像上裁剪区域的宽度
        sHeight: imgHeight / 2, // 源图像上裁剪区域的高度
        dx: 0, // 目标画布上 X 轴的起始位置
        dy: 0, // 目标画布上 Y 轴的起始位置
        dWidth: drawWidth, // 在目标画布上绘制图像的宽度
        dHeight: elementHeight, // 在目标画布上绘制图像的高度
      };
      // 第二张图右侧元素
      const secondRightOptions = rightImg && {
        img: rightImg,
        sx: imgWidth / 2, // 源图像上裁剪区域的 X 轴起始位置
        sy: 0, // 源图像上裁剪区域的 Y 轴起始位置
        sWidth: imgWidth / 2, // 源图像上裁剪区域的宽度
        sHeight: imgHeight / 2, // 源图像上裁剪区域的高度
        dx: elementWidth - drawWidth, // 目标画布上 X 轴的起始位置
        dy: 0, // 目标画布上 Y 轴的起始位置
        dWidth: drawWidth, // 在目标画布上绘制图像的宽度
        dHeight: elementHeight, // 在目标画布上绘制图像的高度
      };
      // 第三张图左侧元素
      const thirdLeftOptions = leftImg && {
        img: leftImg,
        sx: 0, // 源图像上裁剪区域的 X 轴起始位置
        sy: imgHeight / 2, // 源图像上裁剪区域的 Y 轴起始位置
        sWidth: imgWidth / 2, // 源图像上裁剪区域的宽度
        sHeight: imgHeight / 2, // 源图像上裁剪区域的高度
        dx: 0, // 目标画布上 X 轴的起始位置
        dy: 0, // 目标画布上 Y 轴的起始位置
        dWidth: drawWidth, // 在目标画布上绘制图像的宽度
        dHeight: elementHeight, // 在目标画布上绘制图像的高度
      };
      // 第三张图右侧元素
      const thirdRightOptions = rightImg && {
        img: rightImg,
        sx: 0, // 源图像上裁剪区域的 X 轴起始位置
        sy: imgHeight / 2, // 源图像上裁剪区域的 Y 轴起始位置
        sWidth: imgWidth / 2, // 源图像上裁剪区域的宽度
        sHeight: imgHeight / 2, // 源图像上裁剪区域的高度
        dx: elementWidth - drawWidth, // 目标画布上 X 轴的起始位置
        dy: 0, // 目标画布上 Y 轴的起始位置
        dWidth: drawWidth, // 在目标画布上绘制图像的宽度
        dHeight: elementHeight, // 在目标画布上绘制图像的高度
      };
      // 第四张图片
      const fourthLeftOptions = leftImg && {
        img: leftImg,
        sx: imgWidth / 2, // 源图像上裁剪区域的 X 轴起始位置
        sy: imgHeight / 2, // 源图像上裁剪区域的 Y 轴起始位置
        sWidth: imgWidth / 2, // 源图像上裁剪区域的宽度
        sHeight: imgHeight / 2, // 源图像上裁剪区域的高度
        dx: 0, // 目标画布上 X 轴的起始位置
        dy: 0, // 目标画布上 Y 轴的起始位置
        dWidth: drawWidth,  // 在目标画布上绘制图像的宽度
        dHeight: elementHeight, // 在目标画布上绘制图像的高度
      }
      // 第四张图右侧元素
      const fourthRightOptions = rightImg && {
        img: rightImg,
        sx: imgWidth / 2, // 源图像上裁剪区域的 X 轴起始位置
        sy: imgHeight / 2, // 源图像上裁剪区域的 Y 轴起始位置
        sWidth: imgWidth / 2, // 源图像上裁剪区域的宽度
        sHeight: imgHeight / 2, // 源图像上裁剪区域的高度
        dx: elementWidth - drawWidth, // 目标画布上 X 轴的起始位置
        dy: 0, // 目标画布上 Y 轴的起始位置
        dWidth: drawWidth,  // 在目标画布上绘制图像的宽度
        dHeight: elementHeight, // 在目标画布上绘制图像的高度
      }
      const firstImageOptions = [];
      const secondImageOptions = [];
      const thirdImageOptions = [];
      const fourthImageOptions = [];
      if (leftImg) {
        firstImageOptions.push(firstLeftOptions);
        secondImageOptions.push(secondLeftOptions);
        thirdImageOptions.push(thirdLeftOptions);
        fourthImageOptions.push(fourthLeftOptions);
      }
      if (rightImg) {
        firstImageOptions.push(firstRightOptions);
        secondImageOptions.push(secondRightOptions);
        thirdImageOptions.push(thirdRightOptions);
        fourthImageOptions.push(fourthRightOptions);
      }
      const firstImage = firstImageOptions.length && cropImageWithCanvas(firstImageOptions);
      const secondImage = secondImageOptions.length && cropImageWithCanvas(secondImageOptions);
      const thirdImage = thirdImageOptions.length && cropImageWithCanvas(thirdImageOptions);
      const fourthImage = fourthImageOptions.length && cropImageWithCanvas(fourthImageOptions);
      const result = [firstImage, secondImage, thirdImage, fourthImage];
      return result.filter(item => item);
    } catch (error) {
      return [];
    }
  }
  )
}
// 上传多张图片
export const uploadImages = (base64Imgs) => {
  const promises = [];
  base64Imgs.forEach(async (img) => {
    const formData = new FormData();
    formData.append(
      "file",
      base64toFile(img, Math.random().toString(36).slice(-8))
    );
    promises.push(uploadImg(formData));
  });
  return Promise.all(promises).then((results) => {
    return results.map((result) => result.data.result);
  });
}
// 提交ai生成结果
export const saveAiGenerateResult = async (prompt, images) => {
  const result = await http.post(api.saveAiGenerateResult, {
    prompt,
    aiResults: images,
  });

  return result.data;
}
// 翻译
export const translate = async (words) => {
  const result = await http.post(api.translate, {
    words,
  });
  return result.data;
}

// 即梦生图
export const jimengGenImage = async (prompt, model) => {
  const result = await http.post(api.jimengGenImage, {
    prompt,
    model,
  });
  if (result.code === 10000) {
    return result.data.list;
  }
  return [];
}
// gpt编辑图片
export const gptEditImage = async (prompt, model, images) => {
  const result = await http.post(api.gptEditImage, {
    prompt,
    model,
    images,
  });
  if (result.code === 10000) {
    return result.data.list;
  }
  return [];
}
// 即梦生图 | GPT生图 8张图
export const jimengGen8Image = async (leftPrompt, rightPrompt, defaultPrompt, selectedModelId, images) => {
  const modelName = selectedModelId === 3 ? "doubao-seedream-3-0-t2i-250415" : "gpt-image-1";
  const leftPromptStr = defaultPrompt + leftPrompt;
  const rightPromptStr = defaultPrompt + rightPrompt;
  const promises = [];
  for (let i = 0; i < 8; i++) {
    if (i < 4) {
      if (images && images.length && selectedModelId === 4) {
        promises.push(gptEditImage(leftPromptStr, modelName, images));
      } else {
        promises.push(jimengGenImage(leftPromptStr, modelName));
      }
    } else {
      if (images && images.length && selectedModelId === 4) {
        promises.push(gptEditImage(rightPromptStr, modelName, images));
      } else {
        promises.push(jimengGenImage(rightPromptStr, modelName));
      }
    }
  }
  return Promise.all(promises).then((results) => {
    const imgs = results.flat();
    const promises = [];
    imgs.forEach((img) => {
      img && promises.push(removeBackground(img.url));
    });
    return Promise.all(promises).then((results) => {
      return results.map((result) => {
        return result.imageUrl;
      });
    });
  });
  // 'https://ait-img.xkw.com/img-generated/2025080717233245136.png',
  // 'https://ait-img.xkw.com/img-generated/20250807172309728029.png',
  // 'https://ait-img.xkw.com/img-generated/20250807172255815403.png',
  // 'https://ait-img.xkw.com/img-generated/20250807172255687447.png',
  // 'https://ait-img.xkw.com/img-generated/20250807172245803917.png',
  // 'https://ait-img.xkw.com/img-generated/20250807172254249746.png',
  // 'https://ait-img.xkw.com/img-generated/20250807172204227075.png'
  // const arr = [
  //   'https://ait-img.xkw.com/img-generated/20250807172222647331.png',
  //   'https://ait-img.xkw.com/img-generated/20250807172254249746.png',
  //   'https://ait-img.xkw.com/img-generated/20250807172204227075.png',
  //   'https://ait-img.xkw.com/img-generated/20250807172204227075.png'
  // ];
  // const promises = [];
  // arr.forEach((img) => {
  //   promises.push(removeBackground(img));
  // });
  // const result = await Promise.all(promises).then((results) => {
  //   return results.map((result) => {
  //     return result.imageUrl;
  //   });
  // })
  // console.log('result', result);
  // return result;
}
// GPT编辑图 8张图
export const GPTEdit8Image = async (leftPrompt, rightPrompt, defaultPrompt, images) => {
  const modelName = "gpt-image-1";
  const leftPromptStr = defaultPrompt + leftPrompt;
  const rightPromptStr = defaultPrompt + rightPrompt;
  const promises = [];
  for (let i = 0; i < 8; i++) {
    if (i < 4) {
      promises.push(gptEditImage(leftPromptStr, modelName, images));
    } else {
      promises.push(gptEditImage(rightPromptStr, modelName, images));
    }
  }
  return Promise.all(promises).then((results) => {
    const imgs = results.flat();
    return imgs.map((result) => {
      return result.url;
    });
    // const imgs = results.flat();
    // const promises = [];
    // imgs.forEach((img) => {
    //   img && promises.push(removeBackground(img.url));
    // });
    // return Promise.all(promises).then((results) => {
    //   return results.map((result) => {
    //     return result.imageUrl;
    //   });
    // });
  });
}
// mj请求两次图片生成接口
export const mjGen2Image = async (leftPrompt, rightPrompt, defaultPrompt) => {
  return Promise.all([
    mjGenImage(leftPrompt + "," + defaultPrompt),
    mjGenImage(rightPrompt + "," + defaultPrompt),
  ]).then(([leftImg, rightImg]) => {
    const promises = [];
    if (leftImg) {
      promises.push(removeBackground(leftImg));
    } else {
      promises.push(Promise.resolve({ imageUrl: "" }));
    }
    if (rightImg) {
      promises.push(removeBackground(rightImg));
    } else {
      promises.push(Promise.resolve({ imageUrl: "" }));
    }
    return Promise.all(promises).then((results) => {
      return results.map((result) => {
        return result.imageUrl;
      });
    });
  });

}

// 多句子翻译
export const translateSentences = async (strs) => {
  const promises = [];
  strs.forEach(async (str) => {
    if (/[\u4e00-\u9fa5]/.test(str)) {
      promises.push(translate(str));
    } else {
      promises.push(Promise.resolve(str));
    }
  });
  return Promise.all(promises).then((results) => {
    return results.map((result) => {
      if (typeof result === "string") {
        return result;
      } else {
        return result.transResult.reduce((acc, curr) => {
          return acc + curr.dst;
        }, "");
      }
    });
  });
}